<style src="./BoardFiles.scss" lang="scss"></style>
<template>
  <section class="board-files board-module">
    <div class="moduleheader">
      <span class="moduletitle">Arquivos</span>
      <router-link
        class="golink"
        :to="`/event/documents/${eventId}`">
        ir para documentos
        <icon-right-arrow class="iconarrow" />
      </router-link>

    </div>

    <!-- <div class="search">
      <select
        class="cp1-small-select field"
        v-model="form.documentTypeId">
        <option :value="null">SELECIONA O TIPO DE DOCUMENTO</option>
        <option
          v-for="(document, documentIdx) in documentList"
          :key="documentIdx"
          :value="document._id">{{ document.title }}</option>
      </select>
    </div> -->
    <ul class="filelist">
      <li
        class="documentitem"
        v-for="( document, documentIdx) in fileList"
        :key="documentIdx"
        @click="viewDocument(documentIdx, document.documentId, document.fileType)">
        <span class="documenttype">{{ document.documentTypes[0].title }}</span>
        <span class="documentdescription">{{ document.description }}</span>
        <div
          class="waiting"
          v-if="document.submitState === 'WAIT'">
        </div>
      </li>
      <li
        class="morefiles"
        v-if="countFiles">
        e mais <strong>{{ countFiles }}</strong> arquivos.
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { IconRightArrow } from '@/components/primitives/icons'
import PDFObject from 'pdfobject'

export default {
  name: 'BoardFiles',
  components: {
    IconRightArrow
  },
  props: {
    eventId: {
      default: null
    }
  },
  data: () => ({
    form: {
      documentTypeId: null
    },
    fileList: [],
    countFiles: false,
    preLoader: false,
    documentModal: false
  }),
  computed: {
    ...mapGetters({
      documentList: 'DocumentType/LIST'
    })
  },
  mounted () {
    this.loadDocuments()
  },
  methods: {
    async loadDocuments () {
      const payload = {
        eventId: this.eventId
      }
      try {
        this.preLoader = true
        const { list, count } = await this.$store.dispatch('EventDocuments/LIST_BY_EVENT', payload)
        if (list.length < count) {
          this.countFiles = count
        }
        this.fileList = list
      } catch (error) {
        this.$toasted.error('Não foi possível carregar os arquivos')
      } finally {
        this.preLoader = false
      }
    },
    async viewDocument (documentIdx, documentId, fileType) {
      if (this.fileList[documentIdx].submitState === 'WAIT') {
        return
      }
      this.fileList[documentIdx].submitState = 'WAIT'
      const payload = {
        eventId: this.eventId,
        documentId,
        fileType
      }

      try {
        const data = await this.$store.dispatch('EventDocuments/VIEW_DOCUMENT', payload)
        if (fileType === 'application/pdf') {
          this.openAsPdf(data)
        } else {
          this.forceDownload(data)
        }
      } catch (error) {
        this.$toast.error('Não conseguimos fazer o download desse arquivo')
      } finally {
        this.fileList[documentIdx].submitState = 'REPOSE'
      }
    },
    openAsPdf ({ data }) {
      try {
        this.$store.commit('EventDocuments/SHOW_PDF_DOCUMENT', true)
        this.$nextTick(() => {
          const rootPdfViewer = this.$root.$children[0].$refs.previewpdf
          const options = {
            width: '90%'
          }
          PDFObject.embed(data, rootPdfViewer, options)
        })
      } catch (error) {
        return Error(error)
      }
    },
    forceDownload ({ data, fileName }) {
      const bufferData = new Blob([new Uint8Array(data.data)])
      const url = window.URL.createObjectURL(bufferData)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    closeDocumentModal () {
      PDFObject.embed(null, this.$refs.previewpdf)
      this.documentModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/board/components/board-details/components/board-files/BoardFiles.vue